export const c_description_list_GridTemplateColumns_min = {
  "name": "--pf-v6-c-description-list--GridTemplateColumns--min",
  "value": "0",
  "var": "var(--pf-v6-c-description-list--GridTemplateColumns--min)"
};
export default c_description_list_GridTemplateColumns_min;